// I need add conditional if couting is 50
// when click open folder, ofder shound not display but replace by dialog "photo is limit"

import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined'

import MessageAlert from 'app/components/MessageAlert'
import themesConfig from 'app/fuse-configs/themesConfig'
import { makeStyles, Typography } from '@material-ui/core'
import {
  fileToBase64,
  alertSizeOverLimit,
  PHOTO_SIZE_LIMIT_10,
} from 'libs/file'

const useStyles = makeStyles((theme) => ({
  zoneContainer: {
    height: 170,
    width: '100%',
    display: 'flex',
    margin: '0 0 40px 0',
    cursor: 'pointer',
    overflow: 'hidden',
    textAlign: 'center',
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: `${theme.colors['grey-50']}`,
    border: `2px dashed ${theme.colors['neutrals-200']}`,
  },
  zoneInput: {
    display: 'none',
  },
}))
const UploadBox = ({ onUploadPush }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const handleFileUpload = async (files) => {
    const isValid = [...files].every((file) => {
      const fileTypes = file.type.split('/')
      if (fileTypes[0] === 'image') {
        return fileTypes[1] !== 'gif'
      }
      return false
    })
    if (!isValid) {
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'error.400.fileTypeInvalid' }),
        }),
      )
      return
    }
    const base64Files = await Promise.all(
      [...files].map((file) => handleUploadAvatar(file)),
    )
    onUploadPush(base64Files)
  }

  const preventDefaultActions = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const drop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    let dt = e.dataTransfer
    handleFileUpload(dt.files)
  }

  const handleUploadAvatar = (file) =>
    new Promise((resolve) => {
      if (file.size < PHOTO_SIZE_LIMIT_10) {
        fileToBase64(file).then((fileData) => resolve(fileData))
      } else {
        alertSizeOverLimit(dispatch, formatMessage, PHOTO_SIZE_LIMIT_10)
      }
    })

  return (
    <label
      className={classes.zoneContainer}
      onDragLeave={preventDefaultActions}
      onDragEnter={preventDefaultActions}
      onDragOver={preventDefaultActions}
      onDrop={drop}
    >
      <AddPhotoAlternateOutlinedIcon
        style={{
          fontSize: '3rem',
          color: themesConfig.default.colors['secondary'],
        }}
      />
      <Typography className="text-16 text-grey-300">
        <FormattedMessage id="upload.photo.gallery.suggestion" />
      </Typography>
      <Typography className="text-14 text-grey-300">
        <FormattedMessage id="upload.photo.gallery.limit" />
      </Typography>
      <input
        className={classes.zoneInput}
        type="file"
        onClick={(event) => {
          event.target.value = ''
        }}
        onChange={(e) => handleFileUpload(e.target.files)}
        multiple
        accept="image/*"
      />
    </label>
  )
}

UploadBox.propTypes = {
  onUploadPush: PropTypes.func,
}

export default UploadBox
